import moment from "moment";
import { AsYouType } from "libphonenumber-js";

export const getSevenDaysBackDate = () => {
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  return `${sevenDaysAgo.toISOString().substr(0, 10)}`;
};

export const getCurrentDate = () => {
  const todayDate = new Date();
  const year = todayDate.getFullYear();
  const month = String(todayDate.getMonth() + 1).padStart(2, "0");
  const day = String(todayDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getCurrentIndianTime = () => {
  const date = new Date();

  // Get the current UTC time in milliseconds and add the IST offset (5 hours and 30 minutes)
  const utcOffset = date.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  const istOffset = 5.5 * 60 * 60000; // 5.5 hours in milliseconds

  const istTime = new Date(date.getTime() + utcOffset + istOffset);

  let hours = istTime.getHours();
  const minutes = istTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? "0" + minutes : minutes; // ensure two digits for minutes

  const currentIndianTime = `${hours}:${minutesStr} ${ampm}`;
  return currentIndianTime;
};

export const isSalaryPaid = (data, month) => {
  const paymentRecord = data?.monthlyPayment?.find(
    (payment) => payment?.paidMonthsalary === month
  );
  return paymentRecord ? "Paid" : "Not Paid";
};
// export const textBlue-semiBold = 'text-color-blue font-semibold'
export const classesForToggle =
  "w-11 h-6 rounded-full peer-checked:bg-green-500 bg-gray-400 dark:bg-gray-600 peer relative transition-colors after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white dark:border-gray-600";

export const momentDateFormat = (date) => {
  if (!date) return "";

  let parsedDate;

  // Try DD-MM-YYYY first
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    parsedDate = moment(date, "DD-MM-YYYY");
  }
  // Try YYYY-MM-DD
  else if (moment(date, "YYYY-MM-DD", true).isValid()) {
    parsedDate = moment(date, "YYYY-MM-DD");
  }
  // Try auto parse (for Date objects or other ISO formats)
  else if (moment(date).isValid()) {
    parsedDate = moment(date);
  }
  // Invalid
  else {
    console.error("Invalid date format:", date);
    return "";
  }

  return parsedDate.format("DD-MM-YYYY");
};

export const momentCurrentDate = () => {
  return moment(moment()).format("YYYY-MM-DD");
};

export const isPastDate = (date) => {
  if (!date) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const pickupDate = new Date(date);
  return pickupDate < today;
};
export const isPastDateTwoDayAllowed = (date) => {
  if (!date) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const pickupDate = new Date(date);
  pickupDate.setHours(0, 0, 0, 0);

  // Allow 1 day before
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 2);

  return pickupDate < yesterday;
};
export const formatPhoneNumber = (phoneNumber, plus = false) => {
  if (!phoneNumber) return "";

  const formattedNumber = plus
    ? new AsYouType().input(`+${phoneNumber}`)
    : new AsYouType().input(`${phoneNumber}`);

  return formattedNumber;
};

export function getMonthStartAndEnd(year, monthIndex) {
  const startDate = new Date(year, monthIndex, 1);
  const endDate = new Date(year, monthIndex + 1, 0);
  return { startDate, endDate };
}

export function calculateTotalAdvanceWithinRange(
  advancePayments,
  year,
  monthIndex
) {
  // Get the start and end dates of the specified month
  const { startDate, endDate } = getMonthStartAndEnd(year, monthIndex);

  // Calculate the total advance amount paid within the date range
  const totalAdvancePaid = advancePayments.reduce((total, payment) => {
    const paidDate = new Date(payment.paidDate);

    // Check if the paid date is within the start and end dates
    if (paidDate >= startDate && paidDate <= endDate) {
      return total + payment.advanceamountPaid;
    }
    return total;
  }, 0);

  return { totalAdvancePaid };
}

export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};
export const convertToISOFormat = (date) => {
  if (!date || typeof date !== "string") {
    return null; // Or handle this case as needed
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  const [day, month, year] = date.split("-");
  return `${year}-${month}-${day}`; // Rearrange to 'YYYY-MM-DD'
};

export const isDateBetween = (date, startDate, endDate) => {
  const d = new Date(date);
  const start = new Date(startDate);
  const end = new Date(endDate);
  return d >= start && d <= end;
};

export const isDateBeforeToday = (date) => {
  const d = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
};

export const isDateAfterToday = (date) => {
  const d = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d > today;
};

// Date utility functions
export const canCreateBill = (subscription, subscriptionRecipt = []) => {
  const today = new Date(getCurrentDate());
  const startDate = new Date(subscription.startDate);
  const endDate = new Date(subscription.endDate);
  const pauseStartDate = subscription.pauseStartDate
    ? new Date(subscription.pauseStartDate)
    : null;
  const pauseEndDate = subscription.pauseEndDate
    ? new Date(subscription.pauseEndDate)
    : null;

  // 1. Check if today is before start date
  if (today < startDate) {
    return { canBill: false, reason: "Subscription hasn't started yet" };
  }

  // 2. Check if today is after end date
  if (today > endDate) {
    return { canBill: false, reason: "Subscription has expired" };
  }

  // 3. Check if today is during pause period
  if (
    pauseStartDate &&
    pauseEndDate &&
    today >= pauseStartDate &&
    today <= pauseEndDate
  ) {
    return {
      canBill: false,
      reason: "Subscription is paused during this period",
    };
  }

  // 4. Check if subscription is cancelled
  if (subscription.status === "cancelled") {
    return { canBill: false, reason: "Subscription is cancelled" };
  }

  // 5. Check if occurrence limit has been reached
  if (
    subscription.occurence !== undefined &&
    subscription.occurence !== null &&
    subscription.occurence !== ""
  ) {
    const parsedOccurrence = parseInt(subscription.occurence);
    if (isNaN(parsedOccurrence) || parsedOccurrence <= 0) {
      return {
        canBill: false,
        reason:
          "Subscription occurrence limit reached. Please renew subscription.",
      };
    }
  }

  // Date comparison functions
  const isSameDay = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const isSameWeek = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round(Math.abs((date1 - date2) / oneDay));
    const sameYear = date1.getFullYear() === date2.getFullYear();
    return sameYear && diffDays < 7 && date1.getDay() >= date2.getDay();
  };

  const isSameMonth = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth()
    );
  };

  const differenceInDays = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000;
    return Math.round(Math.abs((date1 - date2) / oneDay));
  };

  const differenceInMonths = (date1, date2) => {
    return (
      (date2.getFullYear() - date1.getFullYear()) * 12 +
      (date2.getMonth() - date1.getMonth())
    );
  };

  // Get all receipts and sort by date (newest first)
  const sortedReceipts = subscriptionRecipt
    .map((receipt) => ({
      ...receipt,
      date: new Date(receipt.date),
    }))
    .sort((a, b) => b.date - a.date);

  // Check based on subscription type
  const subscriptionType =
    subscription.subscriptionType || subscription.frequency;

  // If no subscription type is defined, return false with a reason
  if (!subscriptionType) {
    return {
      canBill: false,
      reason: "Subscription type is not defined",
    };
  }

  // Convert to lowercase only if subscriptionType exists
  switch (subscriptionType.toLowerCase()) {
    case "daily":
      if (sortedReceipts.some((receipt) => isSameDay(receipt.date, today))) {
        return {
          canBill: false,
          reason: "Daily bill already created for this date",
        };
      }
      break;

    case "weekly":
      if (sortedReceipts.some((receipt) => isSameWeek(receipt.date, today))) {
        return {
          canBill: false,
          reason: "Weekly bill already created for this week",
        };
      }
      break;

    case "bi-weekly":
    case "biweekly":
      if (sortedReceipts.length > 0) {
        const lastReceiptDate = sortedReceipts[0].date;
        const daysSinceLast = differenceInDays(today, lastReceiptDate);
        if (daysSinceLast < 14) {
          return {
            canBill: false,
            reason: "Bi-weekly bill already created within last 14 days",
          };
        }
      }
      break;

    case "monthly":
      if (sortedReceipts.some((receipt) => isSameMonth(receipt.date, today))) {
        return {
          canBill: false,
          reason: "Monthly bill already created for this month",
        };
      }
      break;

    case "bi-monthly":
    case "bimonthly":
      if (sortedReceipts.length > 0) {
        const lastReceiptDate = sortedReceipts[0].date;
        const monthsSinceLast = differenceInMonths(today, lastReceiptDate);
        if (monthsSinceLast < 2) {
          return {
            canBill: false,
            reason: "Bi-monthly bill already created within last 2 months",
          };
        }
      }
      break;

    default:
      // Handle custom frequencies like "3-months"
      if (subscriptionType.includes && subscriptionType.includes("-months")) {
        const months = parseInt(subscriptionType.split("-")[0]);
        if (sortedReceipts.length > 0) {
          const lastReceiptDate = sortedReceipts[0].date;
          const monthsSinceLast = differenceInMonths(today, lastReceiptDate);
          if (monthsSinceLast < months) {
            return {
              canBill: false,
              reason: `Bill already created within last ${months} months`,
            };
          }
        }
      }
      break;
  }

  // If no restrictions found, billing is allowed
  return { canBill: true };
};

export const formatDateByBusinessPreference = (date, dateFormat) => {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();

  switch (dateFormat) {
    case "DD-MM-YYYY":
      return `${day}-${month}-${year}`;
    case "MM-DD-YYYY":
      return `${month}-${day}-${year}`;
    case "YYYY-MM-DD":
    default:
      return `${year}-${month}-${day}`;
  }
};

export const SaleformatDateByBusinessPreference = (date, dateFormat) => {
  if (!date) return date; // Return the original date if it's empty or null

  // Split the date string into components
  const [day, month, year] = date.split("-");

  // Create a Date object from the components
  const d = new Date(`${year}-${month}-${day}`);

  // Check if the date is valid
  if (isNaN(d.getTime())) {
    console.error("Invalid date format:", date);
    return date; // Return the original date if it's invalid
  }

  const dayFormatted = d.getDate().toString().padStart(2, "0");
  const monthFormatted = (d.getMonth() + 1).toString().padStart(2, "0");
  const yearFormatted = d.getFullYear();

  switch (dateFormat) {
    case "DD-MM-YYYY":
      return `${dayFormatted}-${monthFormatted}-${yearFormatted}`;
    case "MM-DD-YYYY":
      return `${monthFormatted}-${dayFormatted}-${yearFormatted}`;
    case "YYYY-MM-DD":
    default:
      return `${yearFormatted}-${monthFormatted}-${dayFormatted}`;
  }
};

export const productformatDateByBusinessPreference = (date, dateFormat) => {
  const d = new Date(date);
  if (isNaN(d)) return ""; // handle invalid date input gracefully

  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();

  switch (dateFormat) {
    case "DD-MM-YYYY":
      return `${day}-${month}-${year}`;
    case "MM-DD-YYYY":
      return `${month}-${day}-${year}`;
    case "YYYY-MM-DD":
    default:
      return `${year}-${month}-${day}`;
  }
};
export const LogoLoading = () => {
  return (
    <div className='flex flex-col justify-center items-center h-screen w-full fixed top-0 left-0 bg-gradient-to-b from-white to-blue-50 z-50 overflow-hidden'>
      {/* Animated background elements */}
      <div className='absolute inset-0 overflow-hidden'>
        <div
          className='absolute top-1/4 left-1/4 w-64 h-64 bg-blue-100 rounded-full animate-pulse'
          style={{ animationDuration: "4s", opacity: 0.1 }}
        />
        <div
          className='absolute bottom-1/4 right-1/4 w-96 h-96 bg-indigo-100 rounded-full animate-pulse'
          style={{
            animationDuration: "5s",
            animationDelay: "1s",
            opacity: 0.05,
          }}
        />
        <div
          className='absolute top-1/2 left-1/3 w-48 h-48 bg-sky-100 rounded-full animate-pulse'
          style={{
            animationDuration: "3s",
            animationDelay: "0.5s",
            opacity: 0.08,
          }}
        />
      </div>

      {/* Main logo container with bounce */}
      <div className='relative mb-8 animate-float'>
        <div className='relative w-32 h-20'>
          <svg
            viewBox='0 0 110.29 64.38'
            className='w-full h-full drop-shadow-lg'
            xmlns='http://www.w3.org/2000/svg'
          >
            {/* Blue part with wave animation */}
            <path
              fill='#4465b0'
              d='m48.61.17v63.61h-10.29v-5.91c-3.6,4.37-8.92,6.51-15.17,6.51-13.29,0-23.14-9.26-23.14-23.49s9.86-23.4,23.14-23.4c5.92,0,11.15,1.97,14.75,6.17V.17h10.72Zm-10.54,40.72c0-8.74-5.91-14.32-13.63-14.32s-13.63,5.57-13.63,14.32,5.92,14.32,13.63,14.32,13.63-5.57,13.63-14.32Z'
              className='animate-wave'
            />

            {/* Dark blue part with wave animation */}
            <path
              fill='#2b286a'
              d='m98.81,30.61c4.92-2.64,8.2-7.47,8.2-14.03,0-10.11-8.2-16.58-23.51-16.58h-29.89v63.78h31.71c16.4,0,24.96-6.38,24.96-17.31,0-8.29-4.65-13.67-11.48-15.85Z'
              className='animate-wave'
              style={{ animationDelay: "0.1s" }}
            />

            {/* Top spinning element with enhanced animation */}
            <g
              className='origin-center'
              style={{
                animation:
                  "orbit-spin 2s cubic-bezier(0.4, 0, 0.2, 1) infinite",
              }}
            >
              <circle
                fill='#fff'
                cx='87.66'
                cy='19.04'
                r='8.24'
                style={{
                  filter: "drop-shadow(0 0 3px rgba(255, 255, 255, 0.9))",
                }}
              />
              <path
                fill='#fff'
                d='m67.24,32.92h-2.33c-.78,0-1.41-.63-1.41-1.41V6.57c0-.78.63-1.41,1.41-1.41h2.33c4.41,0,10.06,1.97,11.11,7.74-1.38,1.85-1.96,3.58-1.96,6.15s.59,4.53,1.93,6.12c-1.14,5.98-7.03,7.76-11.09,7.76Z'
                style={{
                  filter: "drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))",
                }}
              />
            </g>

            {/* Bottom spinning element with enhanced animation */}
            <g
              className='origin-center'
              style={{
                animation:
                  "orbit-spin 3s cubic-bezier(0.4, 0, 0.2, 1) infinite reverse",
              }}
            >
              <circle
                fill='#fff'
                cx='87.66'
                cy='44.74'
                r='8.24'
                style={{
                  filter: "drop-shadow(0 0 3px rgba(255, 255, 255, 0.9))",
                }}
              />
              <path
                fill='#fff'
                d='m67.24,58.62h-2.33c-.78,0-1.41-.63-1.41-1.41v-24.94c0-.78.63-1.41,1.41-1.41h2.33c4.41,0,10.06,1.97,11.11,7.74-1.38,1.85-1.96,3.58-1.96,6.15s.59,4.53,1.93,6.12c-1.14,5.98-7.03,7.76-11.09,7.76Z'
                style={{
                  filter: "drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))",
                }}
              />
            </g>
          </svg>

          {/* Pulsing rings */}
          <div className='absolute inset-0 border-2 border-blue-200 rounded-full animate-ping-ring' />
          <div
            className='absolute inset-0 border border-blue-100 rounded-full animate-ping-ring'
            style={{ animationDelay: "0.5s", margin: "8px" }}
          />
        </div>
      </div>

      {/* Loading text with typing animation */}
      <div className='relative mt-6'>
        <h2 className='text-l text-gray-600 text-sm mb-2'>
          <span className='inline-block animate-fade-in-out overflow-hidden whitespace-nowrap '>
            Crafting Your Experience .......
          </span>
        </h2>

        {/* Animated dots */}
        <div className='flex justify-center space-x-2'>
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className='w-2 h-2 bg-blue-500 rounded-full animate-bounce-dot'
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>

      {/* Progress bar */}
      <div className='w-48 h-1 bg-gray-200 rounded-full overflow-hidden mt-8'>
        <div className='h-full bg-gradient-to-r from-blue-500 to-indigo-600 animate-progress-bar rounded-full' />
      </div>

      {/* CSS for all animations */}
      <style>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-8px) rotate(1deg);
          }
          66% {
            transform: translateY(4px) rotate(-1deg);
          }
        }

        @keyframes orbit-spin {
          0% {
            transform: rotate(0deg) scale(1);
            filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
          }
          50% {
            transform: rotate(180deg) scale(1.05);
            filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.6));
          }
          100% {
            transform: rotate(360deg) scale(1);
            filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
          }
        }

        @keyframes wave {
          0%,
          100% {
            transform: translateY(0);
          }
          25% {
            transform: translateY(-1px);
          }
          75% {
            transform: translateY(1px);
          }
        }

        @keyframes ping-ring {
          0% {
            transform: scale(0.8);
            opacity: 1;
          }
          70%,
          100% {
            transform: scale(1.4);
            opacity: 0;
          }
        }

        @keyframes typing {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }

        @keyframes bounce-dot {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes progress-bar {
          0% {
            width: 0%;
            transform: translateX(-100%);
          }
          50% {
            width: 100%;
            transform: translateX(0%);
          }
          100% {
            width: 100%;
            transform: translateX(100%);
          }
        }

        @keyframes fade-in-out {
          0%,
          100% {
            opacity: 0.3;
          }
          50% {
            opacity: 1;
          }
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animate-wave {
          animation: wave 3s ease-in-out infinite;
        }

        .animate-ping-ring {
          animation: ping-ring 2s cubic-bezier(0, 0, 0.2, 1) infinite;
          margin: -4px;
        }

        .animate-typing {
          animation: typing 3.5s steps(40, end) infinite alternate;
          width: 0;
        }

        .animate-bounce-dot {
          animation: bounce-dot 1.4s ease-in-out infinite;
        }

        .animate-progress-bar {
          animation: progress-bar 2.5s ease-in-out infinite;
        }

        .animate-fade-in-out {
          animation: fade-in-out 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};
export function generateHexTimeId() {
  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .toUpperCase();

  const hexTime = timestamp.padStart(8, "0").slice(-8);

  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomPart = "";
  for (let i = 0; i < 5; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return hexTime + randomPart;
}

export function generateEanId() {
  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .toUpperCase();

  const hexTime = timestamp.padStart(10, "0").slice(-10);

  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomPart = "";
  for (let i = 0; i < 5; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return hexTime + randomPart;
}

export const optionsForOrderStatus = [
  { label: "All", value: "" },
  { label: "Ordered", value: "ordered" },
  { label: "Received", value: "received" },
  { label: "Shipped", value: "shipped" },
  { label: "Approved", value: "approved" },
  { label: "Partial Delivery", value: "partial_received" },
];

export const dateInyyyMMdd = (dateStr) => {
  const [day, month, year] = dateStr.split("-");
  return new Date(`${year}-${month}-${day}`);
};

export function truncateCommaSeparatedString(str, maxItems = 1) {
  if (!str) return "";
  const arr = str.split(",");
  if (arr.length > 1) {
    const res = arr.slice(0, 1).join(", ") + ` & ${arr.length - 1} more...`;
    return res;
  } else {
    return str;
  }
}
